export default __webpack_public_path__ + "static/media/step-three-promise.49c3669f.jpg";